import React, { useState } from "react";
import useDirtyChecker from "../../../hooks/useDirtyChecker";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { toastSuccess } from "../../../utils/toastUtils";
import GenericActionBar from "../../../Layouts/GenericActionBar/GenericActionBar";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";
import ChipsInput from "../../../components/FormComponents/ChipsInput";

const AccessTemplateEditor = ({ file, templateData, setTemplateData, allGroups, allRoles }) => {
  const [isSaving, setIsSaving] = useState(false);
  const { isDirty, markClean } = useDirtyChecker(templateData);

  const selectedGroupsData = allGroups.filter((group) => templateData.permissions.groups?.includes(group.id));
  const selectedRolesData = allRoles.filter((role) => templateData.permissions.roles?.includes(role.role_code));

  const handleGroups = (groups) => {
    const groupIDs = groups.map((group) => group.id);
    setTemplateData((prev) => ({
      ...prev,
      permissions: { ...prev.permissions, groups: groupIDs }
    }));
  };

  const rolesCallbackfunction = (data) => {
    const roleIDs = data.map((role) => role.role_code);
    setTemplateData((prev) => ({
      ...prev,
      permissions: { ...prev.permissions, roles: roleIDs }
    }));
  };

  const handleDesignation = (data) => {
    setTemplateData((prev) => ({
      ...prev,
      permissions: { ...prev.permissions, designations: data }
    }));
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
      const payload = {
        ...templateData,
        name: file.name
      };
      const { message } = await axiosInstance.patch(`/access-templates/${file.id}`, payload);
      toastSuccess(message || "Access Template saved successfully.");
      markClean();
    } catch (err) {
      handleApiError(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="d_flex flex_column">
      <GenericActionBar
        path={
          <div>
            <em>Access Templates</em> → <span>{file.name}</span>
          </div>
        }
        actions={[
          {
            key: "save",
            icon: "save",
            title: isSaving ? "Saving..." : "Save",
            onClick: isSaving ? undefined : handleSave
          }
        ]}
        options={{
          save: {
            className: `${isDirty ? "save_glowing" : ""} ${isSaving ? "disabled" : ""}`.trim()
          }
        }}
      />

      <div className="template_form_outer">
        <div className="builder_form">
          <MultiSelectBox
            options={allGroups}
            selectedData={selectedGroupsData}
            onChange={handleGroups}
            label="Select Access Groups"
          />
          <MultiSelectBox
            options={allRoles}
            selectedData={selectedRolesData}
            onChange={rolesCallbackfunction}
            label="Allowed Roles"
          />
          <ChipsInput
            inputArray={templateData.permissions.designations || []}
            onChange={handleDesignation}
            label="Enter Designations"
          />
        </div>
      </div>
    </div>
  );
};

export default AccessTemplateEditor;
